/* NailCheck · interacciones de la copia mejorada (sin dependencias) */
(function () {
  'use strict';

  /* ---------- Aparición suave al hacer scroll ---------- */
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.ba-reveal:not(.is-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Diálogos (guía de tallas) ---------- */
  function openDialog(id, trigger) {
    var dialog = document.getElementById(id);
    if (!dialog) return;
    dialog._baTrigger = trigger || null;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('ba-dialog-open');
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
  }
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-ba-open-dialog]');
    if (opener) {
      event.preventDefault();
      openDialog(opener.getAttribute('data-ba-open-dialog'), opener);
      return;
    }
    var closer = event.target.closest('[data-ba-close-dialog]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('ba-dialog')) {
      var rect = event.target.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) closeDialog(event.target);
    }
  });
  document.addEventListener('click', function (event) {
    var expander = event.target.closest('[data-ba-expand]');
    if (!expander) return;
    var target = document.getElementById(expander.getAttribute('data-ba-expand'));
    if (!target) return;
    target.classList.add('is-expanded');
    initReveal(target);
    expander.parentElement.hidden = true;
  });
  document.addEventListener('close', function (event) {
    if (event.target.classList && event.target.classList.contains('ba-dialog')) {
      document.documentElement.classList.remove('ba-dialog-open');
      if (event.target._baTrigger) event.target._baTrigger.focus();
    }
  }, true);

  /* ---------- Vídeos: reproducción automática solo cuando se ven ---------- */
  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-ba-videos]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '');
      var videos = root.querySelectorAll('video');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              if (v.preload === 'none') v.preload = 'metadata';
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.35 });
        videos.forEach(function (v) { io.observe(v); });
      }
      root.querySelectorAll('[data-ba-sound]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.closest('.ba-videos__item').querySelector('video');
          var unmute = v.muted;
          videos.forEach(function (other) {
            other.muted = true;
            var b = other.closest('.ba-videos__item').querySelector('[data-ba-sound]');
            if (b) b.setAttribute('aria-pressed', 'false');
          });
          v.muted = !unmute;
          btn.setAttribute('aria-pressed', unmute ? 'true' : 'false');
          if (unmute) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      });
      var track = root.querySelector('[data-ba-track]');
      root.querySelectorAll('[data-ba-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-ba-scroll') === 'next' ? 1 : -1;
          var item = track.querySelector('.ba-videos__item');
          var step = item ? item.getBoundingClientRect().width + 16 : 300;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- Fecha estimada de entrega (días hábiles) ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function initDelivery(scope) {
    (scope || document).querySelectorAll('[data-ba-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var max = parseInt(el.getAttribute('data-max'), 10) || min;
      var now = new Date();
      var fmt;
      var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      try {
        fmt = new Intl.DateTimeFormat(isEn ? 'en-GB' : 'es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
      } catch (e) {
        fmt = { format: function (d) { return d.toLocaleDateString(); } };
      }
      var from = fmt.format(addBusinessDays(now, min)).replace(/\./g, '');
      var to = fmt.format(addBusinessDays(now, max)).replace(/\./g, '');
      var template = el.getAttribute('data-template') || (isEn ? 'Between [inicio] and [fin]' : 'Entre el [inicio] y el [fin]');
      var target = el.querySelector('[data-ba-delivery-text]');
      if (target) target.textContent = template.replace('[inicio]', from).replace('[fin]', to);
    });
  }

  /* ---------- Selector de packs ---------- */
  /* Clave para comparar colores sin tildes ni mayúsculas: "Blanco" → "blanco" (igual que handleize) */
  var BA_MARKS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');
  function baKey(value) {
    var s = String(value == null ? '' : value).toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(BA_MARKS, '');
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function BaPacks(root) {
    this.root = root;
    try {
      this.data = JSON.parse(root.querySelector('[data-ba-json]').textContent);
    } catch (e) {
      return;
    }
    this.map = {};
    var self = this;
    this.data.variants.forEach(function (v) { self.map[v.q + '|' + v.s + '|' + v.c] = v; });
    this.units = Array.prototype.slice.call(root.querySelectorAll('[data-ba-unit]'));
    this.button = root.querySelector('[data-ba-add]');
    this.buttonPrice = root.querySelector('[data-ba-add-price]');
    this.error = root.querySelector('[data-ba-error]');
    this.tierInputs = Array.prototype.slice.call(root.querySelectorAll('input[data-ba-tier]'));
    this.addonCheck = root.querySelector('[data-ba-addon-check]');
    this.addonVariantEs = (this.addonCheck && this.addonCheck.getAttribute('data-ba-addon-variant-es')) || null;
    this.addonVariantEn = (this.addonCheck && this.addonCheck.getAttribute('data-ba-addon-variant-en')) || null;
    this.addonLangInputs = Array.prototype.slice.call(root.querySelectorAll('[data-ba-addon-lang]'));

    this.tierInputs.forEach(function (input) {
      input.addEventListener('change', function () { self.setTier(input.value); });
    });
    this.units.forEach(function (unit, index) {
      unit.addEventListener('change', function (event) {
        if (event.target.matches('[data-ba-size]') && index === 0) self.fillEmptySizes(event.target.value);
        unit.classList.remove('is-error');
        self.hideError();
        self.updateUnitLabels();
        self.refreshAvailability();
        self.updatePrice();
        if (event.target.matches('[data-ba-color]')) self.showColorMedia(event.target.value);
        var c = self.unitChoice(unit);
        if (c.size && c.color && !self.isAvailable(c.size, c.color)) self.showError(self.unavailableMessage(index));
      });
    });
    this.button.addEventListener('click', function () { self.add(); });

    var params = new URLSearchParams(window.location.search);
    var requested = params.get('pack');
    var initial = this.tierInputs.filter(function (i) { return i.checked; })[0];
    if (requested && this.tierInputs.some(function (i) { return i.value === requested; })) {
      this.setTier(requested, true);
    } else {
      this.setTier(initial ? initial.value : this.tierInputs[0].value, false);
    }
    /* ?color=blanco → ese color queda elegido en todas las unidades (enlaces de la sección «Elige tu color») */
    var requestedColor = params.get('color');
    if (requestedColor) {
      var appliedColor = this.applyColor(requestedColor);
      if (appliedColor) this.showColorMedia(appliedColor);
    }
    this.updateUnitLabels();
    this.refreshAvailability();
    this.initSticky();
  }

  BaPacks.prototype.tierData = function (value) {
    return this.data.tiers.filter(function (t) { return String(t.value) === String(value); })[0];
  };

  BaPacks.prototype.setTier = function (value, syncInput) {
    var tier = this.tierData(value);
    if (!tier) return;
    this.tier = tier;
    this.tierInputs.forEach(function (input) {
      var selected = input.value === String(value);
      if (syncInput !== false) input.checked = selected;
      input.closest('.ba-tier').classList.toggle('is-selected', selected);
    });
    this.units.forEach(function (unit, index) {
      var visible = index < tier.count;
      unit.hidden = !visible;
      unit.querySelectorAll('input').forEach(function (i) { i.disabled = !visible; });
    });
    this.root.classList.toggle('is-multi', tier.count > 1);
    this.updatePrice();
    this.hideError();
    this.refreshAvailability();
  };

  /* El botón muestra el precio real de la variante que se va a añadir (pack + talla y color de la unidad 1) */
  BaPacks.prototype.updatePrice = function () {
    if (!this.buttonPrice || !this.tier) return;
    var html = this.tier.price_html;
    var first = this.units && this.units[0] ? this.unitChoice(this.units[0]) : null;
    if (first && first.size && first.color) {
      var v = this.map[this.tier.value + '|' + first.size + '|' + first.color];
      if (v && v.p) html = v.p;
    }
    this.buttonPrice.innerHTML = html;
  };

  BaPacks.prototype.applyColor = function (wanted) {
    var key = baKey(wanted);
    if (!key) return null;
    var applied = null;
    this.units.forEach(function (unit) {
      var inputs = unit.querySelectorAll('[data-ba-color]');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.getAttribute('data-handle') === key || baKey(input.value) === key || baKey(input.getAttribute('data-label')) === key) {
          input.checked = true;
          applied = input.value;
          break;
        }
      }
    });
    return applied;
  };

  /* Si las variantes de ese color tienen foto asignada, la galería salta a ella */
  BaPacks.prototype.showColorMedia = function (color) {
    var section = this.data.section;
    if (!section || !color) return;
    var tier = this.tier ? String(this.tier.value) : null;
    var match = null;
    this.data.variants.forEach(function (v) {
      if (v.c !== color || !v.m) return;
      if (!match || (tier && String(v.q) === tier && String(match.q) !== tier)) match = v;
    });
    if (!match) return;
    var gallery = document.getElementById('MediaGallery-' + section);
    var target = section + '-' + match.m;
    if (!gallery || !gallery.querySelector('[data-media-id="' + target + '"]')) return;
    var run = function () {
      if (typeof gallery.setActiveMedia !== 'function') return;
      try { gallery.setActiveMedia(target, false); } catch (e) { /* la galería sigue funcionando igual */ }
    };
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('media-gallery').then(run);
    } else {
      run();
    }
  };

  BaPacks.prototype.isAvailable = function (size, color) {
    if (!this.tier) return true;
    var v = this.map[this.tier.value + '|' + size + '|' + color];
    return !!(v && v.available);
  };

  BaPacks.prototype.anyAvailable = function (field, value) {
    var tier = this.tier ? String(this.tier.value) : null;
    return this.data.variants.some(function (v) {
      return (!tier || String(v.q) === tier) && v[field] === value && v.available;
    });
  };

  BaPacks.prototype.markAvailability = function (input, ok) {
    var label = input.closest('label');
    if (!label) return;
    label.classList.toggle('is-unavailable', !ok);
    var hint = label.querySelector('[data-ba-na]');
    if (hint) hint.hidden = ok;
  };

  /* Tallas y colores sin variante disponible (en el pack elegido) quedan tachados */
  BaPacks.prototype.refreshAvailability = function () {
    if (!this.units || !this.tier) return;
    var self = this;
    this.units.forEach(function (unit) {
      var c = self.unitChoice(unit);
      unit.querySelectorAll('[data-ba-color]').forEach(function (input) {
        self.markAvailability(input, c.size ? self.isAvailable(c.size, input.value) : self.anyAvailable('c', input.value));
      });
      unit.querySelectorAll('[data-ba-size]').forEach(function (input) {
        self.markAvailability(input, c.color ? self.isAvailable(input.value, c.color) : self.anyAvailable('s', input.value));
      });
    });
  };

  BaPacks.prototype.unavailableMessage = function (index) {
    var msg = this.data.labels.unavailable;
    if (this.tier && this.tier.count > 1) msg = this.data.labels.unit + ' ' + (index + 1) + ': ' + msg;
    return msg;
  };

  BaPacks.prototype.fillEmptySizes = function (size) {
    var count = this.tier ? this.tier.count : 1;
    this.units.slice(1, count).forEach(function (unit) {
      var chosen = unit.querySelector('[data-ba-size]:checked');
      if (!chosen) {
        var match = unit.querySelector('[data-ba-size][value="' + size.replace(/"/g, '\\"') + '"]');
        if (match) match.checked = true;
      }
    });
  };

  BaPacks.prototype.unitChoice = function (unit) {
    var size = unit.querySelector('[data-ba-size]:checked');
    var color = unit.querySelector('[data-ba-color]:checked');
    return {
      size: size ? size.value : null,
      color: color ? color.value : null,
      colorLabel: color ? (color.getAttribute('data-label') || color.value) : null
    };
  };

  BaPacks.prototype.updateUnitLabels = function () {
    var self = this;
    this.units.forEach(function (unit) {
      var c = self.unitChoice(unit);
      var out = unit.querySelector('[data-ba-unit-summary]');
      if (!out) return;
      var parts = [];
      if (c.size) parts.push(self.data.labels.size + ' ' + c.size);
      if (c.color) parts.push(c.colorLabel);
      out.textContent = parts.join(' · ');
    });
  };

  BaPacks.prototype.showError = function (message) {
    this.error.textContent = message;
    this.error.hidden = false;
  };
  BaPacks.prototype.hideError = function () {
    this.error.hidden = true;
    this.error.textContent = '';
  };

  BaPacks.prototype.add = function () {
    var self = this;
    /* Modo simple: el producto solo tiene la opción «Pack», así que se añade directamente la variante del pack elegido */
    if (this.data.simple) {
      var tierValue = String(this.tier.value);
      var simpleVariant = this.data.variants.filter(function (v) { return String(v.q) === tierValue && v.available; })[0];
      if (!simpleVariant) {
        this.showError(this.data.labels.unavailable);
        return;
      }
      return this.send([{ id: simpleVariant.id, quantity: 1, properties: {} }], simpleVariant);
    }
    var count = this.tier.count;
    var choices = [];
    var firstMissing = null;
    this.units.slice(0, count).forEach(function (unit, index) {
      var c = self.unitChoice(unit);
      if (!c.size || !c.color) {
        unit.classList.add('is-error');
        if (!firstMissing) firstMissing = { unit: unit, index: index, missing: !c.size ? 'size' : 'color' };
      }
      choices.push(c);
    });
    if (firstMissing) {
      var msg = count > 1
        ? self.data.labels.missing_unit.replace('[n]', firstMissing.index + 1)
        : self.data.labels.missing_single;
      this.showError(msg);
      var focusable = firstMissing.unit.querySelector('input:not([disabled])');
      if (focusable) focusable.focus();
      firstMissing.unit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    for (var u = 0; u < choices.length; u++) {
      if (!this.isAvailable(choices[u].size, choices[u].color)) {
        this.showError(this.unavailableMessage(u));
        return;
      }
    }
    var anchor = choices[0];
    var variant = this.map[this.tier.value + '|' + anchor.size + '|' + anchor.color];
    if (!variant || !variant.available) {
      this.showError(self.data.labels.unavailable);
      return;
    }
    var properties = {};
    if (count > 1) {
      choices.forEach(function (c, i) {
        properties[self.data.labels.unit + ' ' + (i + 1)] = self.data.labels.size + ' ' + c.size + ' · ' + c.colorLabel;
      });
    }
    var items = [{ id: variant.id, quantity: 1, properties: properties }];
    /* Infoproducto (Programa NailCheck · 21 Días): se añade como segunda línea del pedido si el comprador marca la casilla, en el idioma elegido */
    if (this.addonCheck && this.addonCheck.checked) {
      var addonLang = 'es';
      var checkedLang = this.addonLangInputs.filter(function (i) { return i.checked; })[0];
      if (checkedLang) addonLang = checkedLang.value;
      var addonRaw = addonLang === 'en' ? this.addonVariantEn : this.addonVariantEs;
      var addonId = addonRaw ? parseInt(addonRaw, 10) : null;
      if (addonId) items.push({ id: addonId, quantity: 1 });
    }
    return this.send(items, variant);
  };

  BaPacks.prototype.send = function (items, variant) {
    var self = this;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    this.button.setAttribute('aria-disabled', 'true');
    this.button.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          self.showError(res.description || res.message || self.data.labels.generic_error);
          return;
        }
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && res.sections['cart-icon-bubble']) {
            var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
            var inner = doc.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ba-pack-selector', productVariantId: variant.id });
          }
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { self.showError(self.data.labels.generic_error); })
      .finally(function () {
        self.button.removeAttribute('aria-disabled');
        self.button.classList.remove('is-loading');
      });
  };

  BaPacks.prototype.initSticky = function () {
    var sticky = document.querySelector('[data-ba-sticky="' + this.root.id + '"]');
    if (!sticky || !('IntersectionObserver' in window)) return;
    var root = this.root;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      });
    });
    io.observe(root);
    var go = sticky.querySelector('[data-ba-sticky-go]');
    if (go) go.addEventListener('click', function () {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  function initPacks(scope) {
    (scope || document).querySelectorAll('[data-ba-packs]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '');
      new BaPacks(root);
    });
  }

  /* ---------- Packs de portada: la tarjeta elegida queda marcada ---------- */
  function initOffers(scope) {
    (scope || document).querySelectorAll('[data-ba-offers]:not([data-ready])').forEach(function (grid) {
      grid.setAttribute('data-ready', '');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ba-offer]'));
      var chosen = cards.filter(function (c) { return c.classList.contains('is-featured'); })[0] || null;
      function mark(card, commit) {
        cards.forEach(function (c) {
          var on = c === card;
          c.style.transitionDelay = '0ms';
          c.classList.toggle('is-featured', on);
          var btn = c.querySelector('.ba-offer__cta');
          if (btn) {
            btn.classList.toggle('ba-btn--ghost', !on);
            if (commit) { if (on) btn.setAttribute('aria-current', 'true'); else btn.removeAttribute('aria-current'); }
          }
          var badge = c.querySelector('.ba-offer__badge');
          if (badge) badge.classList.toggle('ba-badge--soft', !on);
        });
      }
      function choose(card) { chosen = card; mark(card, true); }
      var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
      cards.forEach(function (card) {
        card.addEventListener('click', function () { choose(card); });
        card.addEventListener('focusin', function () { choose(card); });
        if (canHover) card.addEventListener('mouseenter', function () { mark(card, false); });
      });
      if (canHover) grid.addEventListener('mouseleave', function () { if (chosen) mark(chosen, false); });
    });
  }

  function initAll(scope) {
    initReveal(scope);
    initVideos(scope);
    initDelivery(scope);
    initPacks(scope);
    initOffers(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
